import { useEffect, useMemo } from "react";
/* eslint-disable no-mixed-operators */
/*eslint-disable no-eval */
import moment from "moment";
import bigDecimal from "js-big-decimal";
import { v4 as uuidv4 } from "uuid";
import * as service from "../services";
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
/* eslint import/no-webpack-loader-syntax: off */
import matlIconCss from '../assets/styles/material-icons.css?inline';
import styleCss from '../assets/styles/style.css?inline';
import mainCss from '../assets/styles/main.css?inline';
import printCss from '../assets/styles/print.css?inline';
import qmsPrintCss from '../assets/styles/qmsPrint.css?inline';
import dmsPrintCss from '../assets/styles/dms.css?inline';
import idfmtCss from '../assets/styles/Idformatbuilder.css?inline'
import qmsCss from '../assets/styles/qms.css?inline';
import qmsreportsCss from '../assets/styles/qmsreports.css?inline';
import {PrintPreviewPage} from "./printPreviewPage";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { fetchServerTime } from "../services";
import DatePicker from "react-datepicker";
 import { dayjs, convertMomentTimeFormat } from "../components/ConfigurableDate";

export function withRouterV7(WrappedComponent) {
  function WithRouterWrapper(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    return (
      <WrappedComponent
        {...props}
        match={{ params ,url: location.pathname}}
        navigate={navigate}
        location={location}
      />
    );
  }
  
  WithRouterWrapper.displayName = `withRouterV7(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithRouterWrapper;
}

export const startLoading = () => {
  const isTokenExpired = localStorage.getItem("isTokenExpired") || false;
  if (!isTokenExpired)
    if (document.getElementById("loader")) document.getElementById("loader").style.display = "block";
};

export const stopLoading = () => {
  if (document.getElementById("loader")) document.getElementById("loader").style.display = "none";
};

export const isEmpty = (obj) => {
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
};

export const validateEmail = (email) => {
  let pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  return pattern.test(email);
};

export const arrayToMap = (data, key) => {
  let map = {};
  data.map((item) => {
    let _key = item[key];
    if (_key in map) {
      map[_key].push(item);
    } else {
      map[_key] = [item];
    }
    return undefined;
  });
  return map;
};

export const randomString = (length) => {
  let result = [];
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result.push(
      characters.charAt(Math.floor(Math.random() * charactersLength))
    );
  }
  return result.join("");
};

export const randomAlphaString = (length) => {
  let result = [];
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result.push(
      characters.charAt(Math.floor(Math.random() * charactersLength))
    );
  }
  return result.join("");
};

export const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export const myPermissions = (permissions, value) => {
  if (permissions)
    return permissions.filter(
      (item) => item.menu_id === value || item.object_name === value
    )[0];
  else return {};
};

export const myEsignSettings = (settings, value) => {
  if (settings)
    return settings.filter(
      (item) => item.menu_id === value || item.menu_name === value
    )[0];
  else return {};
};
export const myEmailSettings = (settings, value) => {
  if (settings)
    return settings.filter(
      (item) => item.menu_id === value || item.menu_name === value
    )[0];
  else return {};
};

export const getDistinctValArray = (data, key) => {
  return [...new Map(data.map((item) => [item[key], item])).values()];
};

export const removeDuplicates = (data) => {
  return data.filter((item, index) => data.indexOf(item) === index);
};

export const sortByIntVal = (data, key) => {
  return data.sort((a, b) => a[key] - b[key]);
};

export const getMagicNumber = () => {
  let min = 1;
  let max = 100;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const evalExpression = (expression) => {
  try {
    eval(expression);
    return "SUCCESS";
  } catch (e) {
    console.warn(e);
    return "ERROR";
  }
};

export const safeEval = (exp, decimals) => {
  try {
    if (exp === null || exp === undefined || typeof exp !== 'string' || exp.toLowerCase().includes('null')) {
      return null;
    }
    const result = eval(exp);
    if (decimals) return result.toFixed(decimals); 
    else return result; 
  } catch (e) {
    console.error("EVAL ERROR:", exp, e);
    return null;
  }
};

export const checkFileSize = (_files) => {
  let filesize = 0;
  let checkIfAllowedFilesize = true;
  for (let i = 0; i < _files.length; i++) {
    if (_files[i].size >= 1024) {
      filesize = Math.ceil(_files[i].size / 1024);
      if (filesize > 10240) {
        checkIfAllowedFilesize = false;
      }
    }
  }
  return checkIfAllowedFilesize;
};

export const replaceSpecialChars = (_str) => {
  let fname = "";
  let splits = _str.split(".");
  for (let i = 0; i < splits.length - 1; i++) {
    fname = fname + splits[i];
  }
  let fupname = fname.replace(/[&/#,+()$~%.'":*?<>{}\s+]/g, "_");
  let finalName = fupname + "." + splits[splits.length - 1];
  return finalName;
};

export const getMonthNumber = (monthName) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  //const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  let ret = 0;
  monthNames?.map((item, index) => {
    if (item.toUpperCase() === monthName?.toUpperCase()) ret = index + 1;
    return item;
  });
  return ret;
};

export const getdate = (_str) => {
  let temp = undefined;
  let _date = undefined;
  let date_str = _str.trim();
  // temp = date_str.split("-");
  if (date_str.includes('/')){
    temp = date_str.split("/");
  } else {
    temp = date_str.split("-");
  }
  _date = temp[2] + "-" + getMonthNumber(temp[1]) + "-" + temp[0];
  _date = new Date(_date);
  return _date;
};

export const customLookup = (_str, no) => {
  let _Lookup = [];
  for (let i = 1; i <= no; i++) {
    _Lookup.push({ value: i, label: _str + " - " + i });
  }
  return _Lookup;
};

// export const getNow = (_format) => {
//   return moment(new Date()).format(_format ? _format : "DD-MMM-yyyy hh:mm A");
// };


let latestServerTime = null; // raw ISO string
let latestMoment = null;     // moment object for ticking
let isFetching = false;

const refreshServerTime = () => {
  if (isFetching) return;
  isFetching = true;

  fetchServerTime()
    .then(serverTime => {
      if (serverTime) {
        latestServerTime = serverTime;
        latestMoment = moment(serverTime);
      }
    })
    .catch(err => console.error("Error fetching server time:", err))
    .finally(() => { isFetching = false; });
};
refreshServerTime();
setInterval(() => {
  if (latestMoment) {
    latestMoment.add(1, "seconds");
    latestServerTime = latestMoment.toISOString();
  }
}, 1000);
setInterval(refreshServerTime, 1 * 60 * 1000);
export const getNow = (_format) => {
  const formatStr = _format || "DD-MMM-yyyy hh:mm A";
  if (!latestMoment) return "Loading..."; 
  return latestMoment.format(formatStr);
};
export const newDate = () => {
  if (!latestMoment) return "Loading server time...";
  return latestMoment.toDate();
}

export const getlatestNoW = (timezone, dateFormat, timeFormat) => {
    if (!latestMoment) return "Loading...";
    const momentDateFormat = dateFormat
        .replace(/MMM/g, 'MMM')
        .replace(/Mon/g, 'MMM');
    const momentTimeFormat = timeFormat
        .replace(/HH24/g, 'HH')
        .replace(/HH12/g, 'hh')
        .replace(/MI/g, 'mm')
        .replace(/ AM/g, ' A');

    const tzDate = new Date(
        latestMoment.toDate().toLocaleString('en-US', {
            timeZone: timezone
        })
    );
    return moment(tzDate).format(
        `${momentDateFormat} ${momentTimeFormat}`
    );
};

export const getCurrentDate = (timezone, dateFormat) => {
  if (!latestMoment) return "Loading...";

  const momentDateFormat = dateFormat
      .replace(/MMM/g, 'MMM')
      .replace(/Mon/g, 'MMM');

  const tzDate = new Date(
        latestMoment.toDate().toLocaleString('en-US', {
            timeZone: timezone
        })
    );

    return moment(tzDate).format(`${momentDateFormat}`);
};

export const formatCustomFieldDate = (
    value,
    sourceFormat = 'DD-MMM-YYYY',
    targetFormat = 'DD-MMM-YYYY'
) => {
    if (!value || value === 'Invalid date') return '';
    return moment(
        moment(value, sourceFormat).toDate()
    ).format(targetFormat);
};

export const genRandomUUID = () => {
  // Generates a UUID v4
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};
export const convertUTCtoIST = (date, format) => {
  try {
    let gmtDateTime = moment.utc(date, format ? format : "DD-MMM-yyyy HH:mm")
    return gmtDateTime.local().format(format ? format : 'DD-MMM-yyyy hh:mm A');
  } catch (e) {
    console.warn(e);
  }
};

export const convertUTCtoIST1 = (date, format) => {
  try {
    let gmtDateTime = moment.utc(date, format ? format : "DD-MMM-yyyy HH:mm:ss");
    return gmtDateTime.local().format(format ? format : "DD-MMM-yyyy hh:mm:ss A");
  } catch (e) {
    console.warn(e);
  }
};
export const getDateFormatSetter =(date)=> {
  if (!date) return "--";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const monthNames = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
  ];
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}


// export const formatCurrency = (price, decimal) => {
//   try {
//     return bigDecimal.getPrettyValue(bigDecimal.round(price, decimal || 0)).replace(/,/g, '');
//   } catch (e) {
//     console.warn(e);
//   }
// };

export const formatCurrency = (price, decimal) => {
  try {
      decimal = parseInt(decimal, 10) || 0;
      const factor = Math.pow(10, decimal);
      const roundedPrice = Math.round((price + Number.EPSILON + 1e-10)* factor) / factor;
      let formattedPrice = roundedPrice.toFixed(decimal);
      formattedPrice = formattedPrice.replace(/,/g, '');
      return formattedPrice;
  } catch (e) {
    console.warn(e);
  }
};

export const standardDeviation = (arr, decimal) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return null;
  }
  if (arr.some(v => v === null || v === undefined || Number.isNaN(v))) {
    return null;
  }
  let mean = arr.reduce((a, b) => a + b) / arr.length;
  arr = arr.map((k) => (k - mean) ** 2);
  let sum = arr.reduce((acc, curr) => acc + curr, 0);
  return bigDecimal.getPrettyValue(
    bigDecimal.round(Math.sqrt(sum / (arr.length - 1)), decimal || 0)
  );
};

export const relativeStandardDeviation = (arr, decimal) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return null;
  }
  if (arr.some(v => v === null || v === undefined || Number.isNaN(v))) {
    return null;
  }
  let mean = arr.reduce((a, b) => a + b) / arr.length;
  arr = arr.map((k) => (k - mean) ** 2);
  let sum = arr.reduce((acc, curr) => acc + curr, 0);
  let stdDeviation = Math.sqrt(sum / (arr.length - 1));
  return bigDecimal.getPrettyValue(
    bigDecimal.round(stdDeviation * (100 / mean), decimal || 0)
  );
};

export const getAddress = (_data, formatted) => {
  if (formatted) {
    return (
      <>
        <h1 style={{ fontSize: "16px" }}>{_data.address1}</h1>
        <div>
          {_data.address2 || ""}
          {_data.address2 && (_data.address3 || _data.address4) ? ", " : ""}
          {(_data.address3 || _data.address4 )|| ""}
        </div>
        <div>
          {_data.city || ""}
          {_data.city && _data.state ? ", " : ""}
          {_data.state || ""}
          {_data.state && _data.country_name ? ", " : ""}
          {_data.country_name || ""}
        </div>
      </>
    );
  } else {
    let ret = _data.address1;
    if (_data.address2) ret = ret + ", " + _data.address2;
    if (_data.address3) ret = ret + ", " + _data.address3;
    if (_data.city) ret = ret + ", " + _data.city;
    if (_data.country_name) ret = ret + ", " + _data.country_name;
    return ret;
  }
};

export const diffArray = (left, right, compareFunction) =>
  left.filter(
    (leftValue) =>
      !right.some((rightValue) => compareFunction(leftValue, rightValue))
  );

export const getLegoPayload = (data, type) => {
  let payload = {};
  let whereClause = [];
  if (type === "p") {
    whereClause = data.map((item) => {
      return { param_name: item.key, param_value: item.value };
    });
    payload.parameter_mapping = whereClause;
  }
  if (type === "w") {
    whereClause = data.map((item) => {
      return {
        field_name: item.key,
        operator: item.operator,
        values: item.value,
      };
    });
    payload["where"] = whereClause;
  }
  //  whereClause.push({ param_name: 'sr_id', param_value: this.props.match.params.id, param_is_identifier: false });
  if (type === "i") {
    whereClause = data.map((item) => {
      return {
        param_name: item.key,
        param_value: item.value,
        param_is_identifier: false,
      };
    });
    payload["parameter_mapping"] = whereClause;
  }
  return payload;
};

if (typeof globalThis !== 'undefined') {
  if (!globalThis.crypto) {
    globalThis.crypto = {};
  }
  if (typeof globalThis.crypto.randomUUID !== 'function') {
    try {
      globalThis.crypto.randomUUID = () => uuidv4();
    } catch (_) {}
  }
}

export const getUUID = () => {
  try {
    return uuidv4();
  } catch (_) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
};

export const sanitizeData = (obj) => {
  if (typeof obj === "object") {
    const delKeys = [
      "keywords",
      "canonical_name",
      "updated_by_id",
      "updated_by_name",
      "updated_at",
      "updated_at_dt",
      "created_at_srt",
      "updated_at_srt",
    ];
    let _delKeys = Object.keys(obj).filter(
      (item) => delKeys.includes(item) || item.endsWith("_srt")
    );
    _delKeys.map((key) => delete obj[key]);
  }
  return obj;
};

export const validateCustomFields = (customFields) => {
  let isValid = true;
  if (customFields) {
    customFields = customFields.filter(item => item.status_id === 'ACTIVE').map((c) => {
      delete c.error;
      if (
        ((c.show_by_default && c.is_mandatory) ||
          (c.is_manual_configure && c.is_mandatory)) &&
        (!c.field_data || c.field_data.length <= 0)
      ) {
        isValid = false;
        c.error =
          c.custom_field_type_id === "TEXT_BOX" ||
            c.custom_field_type_id === "NUMERIC_VALUE"
            ? "Please Enter value for " + c.name + "."
            : "Please Select value for " + c.name + ".";
      }
      return c;
    });
  }
  return { customFields, isValid };
};

export const qmsDuplicateCheck = (site_id, field_name, value, object_id, cb) => {
  console.log(site_id, field_name, value, object_id,"utilld")
  service.executeQuery(
    {
      path: "qms_utils/qms_duplicate_check",
      query_params: {
        parameter_mapping: [
          { param_name: "site_id", param_value: site_id },
          { param_name: "field_name", param_value: field_name },
          { param_name: "value", param_value: value },
          { param_name: "menu_id", param_value: object_id },
        ],
      },
    },
    (res) => {
      cb({ is_exist: res.data[0] });
    }
  );
};
export const dmsDuplicateCheck = (site_id, field_name, value, object_id, cb) => {
  service.executeQuery(
    {
      path: "dms_utils/dms_duplicate_check",
      query_params: {
        parameter_mapping: [
          { param_name: "site_id", param_value: site_id },
          { param_name: "field_name", param_value: field_name },
          { param_name: "value", param_value: value },
          { param_name: "menu_id", param_value: object_id },
        ],
      },
    },
    (res) => {      
      cb({ is_exist: res.data[0]});
    }
  );
};

export const duplicateCheck = (site_id, field_name, value, object_id, cb) => {
  service.executeQuery(
    {
      path: "utils/duplicate_check",
      query_params: {
        parameter_mapping: [
          { param_name: "site_id", param_value: site_id },
          { param_name: "field_name", param_value: field_name },
          { param_name: "value", param_value: value },
          { param_name: "menu_id", param_value: object_id },
        ],
      },
    },
    (res) => {
      cb({ is_exist: res.data[0] });
    }
  );
};

export const duplicatelocationCheck = (site_id, credentials, object_id, cb) => {
  service.executeQuery(
    {
      path: "utils/duplicate_server_loc_check",
      query_params: {
        parameter_mapping: [
          { param_name: "site_id", param_value: site_id },
          { param_name: "ip_address", param_value: credentials.ip_address },
          { param_name: "port", param_value: credentials.port },
          { param_name: "sftp_username", param_value: credentials.sftp_username },
          { param_name: "sftp_user_password", param_value: credentials.sftp_user_password },
          { param_name: "file_location", param_value: credentials.file_location },
          { param_name: "menu_id", param_value: object_id },
        ],
      },
    },
    (res) => {
      cb({ is_exist: res.data[0] }); 
    }
  );
};

export const getFormattedDate = (_date) => {
  let date = new Date(_date);
  return date.toISOString().slice(0, 10);
};

export const loadLabelPrintCss = (pf) => {
  const css = `${matlIconCss}${styleCss}${mainCss}`;
  try {
    let ccss = `
    @media print{@page{size:A4;width:100%!important;height:100%!important}.print-break{page-break-after:always}table,td,th{color:#000!important}h1{font-size:20pt}h2,h3,h4{font-size:12pt}a,article a[href^="#"]:after,blockquote,pre{page-break-inside:avoid}h1,h2,h3,h4,h5,h6,img{page-break-after:avoid;page-break-inside:avoid}dl,ol,ul{page-break-before:avoid}a,a:link,a:visited{background:0 0;color:#520;font-weight:700;text-decoration:underline;text-align:left}a[href^=http]:after{content:" < "attr(href) "> "}a:after>img{content:""}.section{padding-top:0}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}.column.is-narrow,.label-bordered {border: 1px solid #000;border-radius: 10px;.column.is-narrow~.column{display:inline-block}.column.is-6{max-width:50%}.columns:last-child,.field:not(:last-child){margin:0!important}}.label-container{border-color:#333;margin:2mm;font-family:courier-std,monospace!important;font-weight:400;font-size:3mm;color:#000;padding:2.5mm;line-height:normal}b{font-weight:700}.pd-1{padding:.1mm .6mm}.pd-2{padding:2mm}.label-row{display:flex;display:-ms-flexbox;display:-moz-box;display:-webkit-flex;flex-direction:row;line-height:normal}.label-column{flex-grow:1}.direction-column{flex-direction:row!important;justify-content:space-between}.direction-row{flex-direction:column!important;justify-content:space-between}.direction-row>div{padding:1mm 2mm!important}.is-half{width:50%}.label-flex-grow-0{flex-grow:0}.is-wrap{flex-wrap:wrap}.is-nowrap{flex-wrap:nowrap}.table.label-container td{display:block}.table.label-container tr td{align-items:flex-start;background:#fff;display:flex;flex-direction:column;margin-bottom:0}        
    `;
    pf(ccss + css);
  } catch (e) {
    pf("");
  }
};

export const getTomorrowDate = (length) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};

export const renderColumnHeaders = (columns, id) => {
  return (
    columns && (
      <thead>
        <tr>
          {columns.map((item, index) => {
            return (
              <th
                {...( (item.renderer_params && item.renderer_params.object_id && item.renderer_params.object_id === "LIMS_RETAIN_SAMPLE_EXECUTION") ? '' : { scope: "col", style: { width: `${100/columns.length}%`,wordBreak:'break-word',  minWidth: `${100/columns.length}%`} })}
                key={id + index}
              >
                {item.label}
              </th>
            );
          })}
        </tr>
      </thead>
    )
  );
};

export const renderQmsHistoryColumnHeaders = (columns, id) => {
  return (
    columns && (
      <thead>
        <tr>
          {columns.map((item, index) => {
            return (
              <th
                {...( (item.renderer_params && item.renderer_params.object_id ) ? '' : { scope: "col", style: { width: `${100/columns.length}%`,wordBreak:'break-word',textAlign: 'center',  minWidth: `${100/columns.length}%`} })}
                key={id + index}
              >
                {item.label}
              </th>
            );
          })}
        </tr>
      </thead>
    )
  );
};

export const RenderQMSColumnHeaders = ({columns, id, onHeaderClick, activeSortKey, qms_search_string, onSearchChange, showSearchBox, showSearchBarHandler, searchInputRef, props, is_print}) => {
  return (
    columns && (
      <thead>
        <tr>
          {columns.map((item, index) => {
            let headerSortField;
            if (Array.isArray(item?.renderer_params)) {
              headerSortField = item.renderer_params
                .map(r => r.label)
                .join(" || ' ' || ");
            } else if (Array.isArray(item?.renderer_params?.labels)) {
              headerSortField = item.renderer_params.labels
                .join(" || ' ' || ");
            } else {
              headerSortField = item?.renderer_params?.label;
            }
            const isActive = activeSortKey === headerSortField;
            const isSearchActive = showSearchBox === item.label;
            return (
              <th
                key={id + "_header_" + index}
                scope="col"
                className={`qms-grid-header ${
                  isActive ? "qms-grid-header--active" : ""
                }`}
              >
                <div className="is-flex is-justify-content-space-between is-align-items-baseline">
                  <div className="is-flex is-align-items-center">
                    <div
                      className={`qms-search-icon ${
                        isActive ? "qms-search-icon--active" : ""
                      }`}
                      onClick={() => onHeaderClick(item)}
                    >
                      <span className="mdi mdi-swap-vertical" style={{ visibility: is_print ? "hidden" : "visible" }}></span>
                    </div>
                    {(item.label !== "Status" && item.label !== "Tab Status") && (<div>{item.label}</div>)}
                  </div>
                  {(item.label === "Status" || item.label === "Tab Status") && (<div
                    className="has-text-centered w-100" 
                  >
                    {item.label}
                  </div>)}
                  <div
                    className={`qms-search-icon ${
                      isSearchActive ? "qms-search-icon--active" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      showSearchBarHandler(item.label);
                    }}
                  >
                    <span className="mdi mdi-magnify mr-2" style={{ visibility: is_print ? "hidden" : "visible" }}></span>
                  </div>
                </div>
              </th>
            );
          })}
        </tr>
        <tr className="qms-search-row qms-search-row--active">
          {columns.map((item, index) => {
            const isSearchActive = showSearchBox?.[item.label];
            return (
              <th key={id + "_filter_" + index}>
                <div
                  className={`qms-search-wrapper pl-2 pr-2 ${
                    isSearchActive ? "qms-search-wrapper--active" : ""
                  }`}
                >
                  {isSearchActive && (
                    <>
                      {item.data_type === "string" || item.data_type === "number" ? (
                        <input
                          ref={isSearchActive ? searchInputRef : null}
                          type="text"
                          className="input"
                          placeholder="Enter Search Param"
                          value={
                            Array.isArray(item?.renderer_params) ||
                            Array.isArray(item?.renderer_params?.labels)
                              ? qms_search_string?.[`${item.label}`]?.value || ""
                              : qms_search_string?.[item.label]?.value || ""
                          }
                          onChange={(e) => {
                            let stateKey = item.label;
                            let propToSend;
                            //Case 1: renderer_params is ARRAY (Address)
                            if (Array.isArray(item?.renderer_params)) {
                              stateKey = `${item.label}`;
                              propToSend = item.renderer_params.map(r => r.label);
                            }
                            // Case 2: renderer_params.labels is ARRAY (Site Name)
                            else if (Array.isArray(item?.renderer_params?.labels)) {
                              stateKey = `${item.label}`;
                              propToSend = item.renderer_params.labels;
                            }
                            // Case 3: normal single field
                            else {
                              propToSend = item?.renderer_params?.label;
                            }
                            onSearchChange(stateKey, e.target.value, propToSend,item.data_type);
                          }}
                        />
                      ) : (
                        <DatePicker
                          placeholderText="Select Date"
                          selected={
                            qms_search_string?.[item.label]?.value
                              ? moment(qms_search_string[item.label].value, (props.me.current_auth.react_date_format || "yyyy-MM-dd").replace(/dd/g, "DD").replace(/yyyy/g, "YYYY")).toDate()
                              : null
                          }
                          className="input"
                          onChange={(date) => {
                              let searchField = item?.renderer_params?.label;
                              if ( item.data_type === "date" || item.data_type === "datetime") {
                                  if (searchField?.endsWith("_dt")) {
                                      searchField = searchField.replace("_dt", "");
                                  }
                              }
                              onSearchChange(
                                  item.label,
                                  date,
                                  searchField,
                                  item.data_type
                              );
                          }}
                          dateFormat={props.me.current_auth.react_date_format && !props.me.meta.is_root_user ? props.me.current_auth.react_date_format : "yyyy-MM-dd"}
                          showMonthDropdown
                          maxDate={new Date(getNow())}
                        />
                      )}
                    </>
                  )}
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
    )
  );
};

export const QMSRenderColumnWidths = ({ columns, id }) => {
  return (
    columns && (
      <colgroup>
        {columns.map((item, index) => {
          const isLastColumn = index === columns.length - 1;
          let width;
          if (columns.length >= 7) {
            width = isLastColumn ? "20%" : `${80 / (columns.length - 1)}%`;
          } else {
            width = `${100 / columns.length}%`;
          }
          return (
            <col key={`${id}${index}_col`} span={1} style={{ width }}/>
          );
        })}
      </colgroup>
    )
  );
};

export const getTransactionStatus = (item) => {
  const actionType = item.action_type?.toUpperCase();
        const approvalStatus = item.approval_status?.toUpperCase();
        // 1. SAVE → Saved
        if (actionType === "SAVE") {
            return {
                label: "SAVED",
                className: "saved"
            };
        }
        // 2. INSERT + empty approval → Created
        if (actionType === "INSERT" && !approvalStatus) {
            return {
                label: "CREATED",
                className: "created"
            };
        }
        // 3. INSERT or UPDATE + APPROVE → Approved
        if ((actionType === "INSERT" || actionType === "UPDATE" ) && approvalStatus === "APPROVE") {
            return {
                label: "APPROVED",
                className: "approved"
            };
        }
        // 4. INSERT or UPDATE + REVERT → Reverted
        if ((actionType === "INSERT" || actionType === "UPDATE" ) && approvalStatus === "REVERT") {
            return {
                label: "REVERT",
                className: "reverted"
            };
        }
        // 4. INSERT or UPDATE + CONSIGNED → CONSIGNED
        if ((actionType === "INSERT" || actionType === "UPDATE" ) && approvalStatus === "CONSIGNED") {
            return {
                label: "CONSIGNED",
                className: "consigned"
            };
        }
        // 5. INSERT or UPDATE + RESUBMIT → Resubmit
        if ((actionType === "INSERT" || actionType === "UPDATE" ) && approvalStatus === "RESUBMIT") {
            return {
                label: "RESUBMIT",
                className: "resubmit"
            };
        }
        // default fallback (future-proof)
        return {
            label: approvalStatus || actionType || "--",
            className: "default"
        };
}

export const renderColumnWidths = (columns, id) => {
  return (
    columns && (
      <colgroup>
        {columns.map((item, index) => {
          return (
            <col
              key={id + index + "_col"}
              span="1"
              {...((item.renderer_params && item.renderer_params.object_id && item.renderer_params.object_id === "LIMS_RETAIN_SAMPLE_EXECUTION") ? '' : { span: 1, style: { width:`${100/columns.length}%` ,wordBreak:'break-word',  minWidth: `${100/columns.length}%` } })}
            />
          );
        })}
      </colgroup>
    )
  );
};

export const getTemplateFields = (path, object_id, reference_id, cb) => {
  service.executeQuery({
    path,
    query_params: {
      parameter_mapping: [
        { param_name: 'object_id', param_value: object_id },
        { param_name: 'reference_id', param_value: reference_id }
      ]
    }
  }, res => {
    let { custom_Fields, temp_data, footer_coa, footer_datasheet, investigation_coa } = res.data[0].temp_data;
    if (custom_Fields && custom_Fields.length > 0) {
      custom_Fields.map(item => {
        temp_data[item.key] = item.value
        return item;
      })
    }
    // if (custom_Fields?.length) {
    //   custom_Fields.forEach(item => {
    //     temp_data[item.key] = item.value;
    //   });
    // }

    let coa_template_data_fields_values = { ...temp_data };
    if (coa_template_data_fields_values && footer_coa?.length) {
      footer_coa.forEach(item => {
        coa_template_data_fields_values[item.key] = item.value;
        if (item.signature_attachment?.TypeimgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = item.signature_attachment.TypeimgSrc;
        }
        else if ( item.signature_attachment?.imgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = (item.signature_attachment?.imgSrc);
        }
      });
    }

    if (coa_template_data_fields_values.is_released === true && investigation_coa?.length) {
      

      investigation_coa.forEach(item => {
        const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
        const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
        const isFooterEmpty = footerData.every(item => !item.value);
        const footerItem = footer_coa.find(footerItem => footerItem.key === item.key);
        investigation_coa.forEach(item => {
          if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
            coa_template_data_fields_values[item.key] = item.value;
          }
        });
        if (item.key === 'approved_by') {
          if ((footerItem && item.value1 > footerItem.value1 && item.value)) {
            const details = investigation_coa.find(footerItem => footerItem.key === 'authorized_by')
            if (details === undefined) {
              coa_template_data_fields_values[item.key] = item.value;
            }
          }

        }
        if (item.key === 'authorized_by') {
          if (footerItem && item.value1 > footerItem.value1 && item.value) {
            coa_template_data_fields_values[item.key] = item.value;
          }}
      })
    }
    if (coa_template_data_fields_values) {
      if (coa_template_data_fields_values.checked_by === '') {
        coa_template_data_fields_values.checked_by = '--'
      }
      if (coa_template_data_fields_values.reviewed_by === '') {
        coa_template_data_fields_values.reviewed_by = '--'
      }
      if (coa_template_data_fields_values.approved_by === '') {
        coa_template_data_fields_values.approved_by = '--'
      }
      if (coa_template_data_fields_values.authorized_by === '') {
        coa_template_data_fields_values.authorized_by = '--'
      }
    }
    let datasheet_template_data_fields_values = { ...temp_data };
    if (footer_datasheet && footer_datasheet.length > 0) {
      footer_datasheet.map(item => {
        datasheet_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    cb({ coa_template_data_fields_values, datasheet_template_data_fields_values, investigation_coa });
  });
}

export const getTestingTemplateFields = (path, object_id, reference_id,sample_inward_id, cb) => {
  service.executeQuery({
    path,
    query_params: {
      parameter_mapping: [
        { param_name: 'object_id', param_value: object_id },
        { param_name: 'reference_id', param_value: reference_id },
        {param_name:'sample_inward_id',param_value:sample_inward_id}
      ]
    }
  }, res => {
    console.log('res: ', res);
    const tempData = res?.data?.[0]?.temp_data || {};
    let { custom_Fields, footer_coa, footer_datasheet, investigation_coa } = tempData;
    const temp_data = tempData?.temp_data || {};
    console.log('temp_data: ', temp_data);
    if (custom_Fields && custom_Fields.length > 0) {
      custom_Fields.map(item => {
        temp_data[item.key] = item.value
        return item;
      })
    }
    // if (custom_Fields?.length) {
    //   custom_Fields.forEach(item => {
    //     temp_data[item.key] = item.value;
    //   });
    // }

    let coa_template_data_fields_values = { ...temp_data };
    if (coa_template_data_fields_values && footer_coa?.length) {
      footer_coa.forEach(item => {
        coa_template_data_fields_values[item.key] = item.value;
        if (item.signature_attachment?.TypeimgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = item.signature_attachment.TypeimgSrc;
        }
        else if ( item.signature_attachment?.imgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = (item.signature_attachment?.imgSrc);
        }
      });
    }

    if (coa_template_data_fields_values.is_released === true && investigation_coa?.length) {
      

      investigation_coa.forEach(item => {
        const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
        const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
        const isFooterEmpty = footerData.every(item => !item.value);
        const footerItem = footer_coa.find(footerItem => footerItem.key === item.key);
        investigation_coa.forEach(item => {
          if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
            coa_template_data_fields_values[item.key] = item.value;
          }
        });
        if (item.key === 'approved_by') {
          if ((footerItem && item.value1 > footerItem.value1 && item.value)) {
            const details = investigation_coa.find(footerItem => footerItem.key === 'authorized_by')
            if (details === undefined) {
              coa_template_data_fields_values[item.key] = item.value;
            }
          }

        }
        if (item.key === 'authorized_by') {
          if (footerItem && item.value1 > footerItem.value1 && item.value) {
            coa_template_data_fields_values[item.key] = item.value;
          }}
      })
    }
    if (coa_template_data_fields_values) {
      if (coa_template_data_fields_values.checked_by === '') {
        coa_template_data_fields_values.checked_by = '--'
      }
      if (coa_template_data_fields_values.reviewed_by === '') {
        coa_template_data_fields_values.reviewed_by = '--'
      }
      if (coa_template_data_fields_values.approved_by === '') {
        coa_template_data_fields_values.approved_by = '--'
      }
      if (coa_template_data_fields_values.authorized_by === '') {
        coa_template_data_fields_values.authorized_by = '--'
      }
    }
    let datasheet_template_data_fields_values = { ...temp_data };
    if (footer_datasheet && footer_datasheet.length > 0) {
      footer_datasheet.map(item => {
        datasheet_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    cb({ coa_template_data_fields_values, datasheet_template_data_fields_values, investigation_coa });
  });
}


export const getPartialCOATemplateFields = (path, object_id, reference_id,sample_inward_id, partial_id, cb) => {
  const params = [
  { param_name: 'object_id', param_value: object_id },
  { param_name: 'reference_id', param_value: reference_id },
  { param_name: 'id', param_value: partial_id }
];

if (object_id === 'LIMS_TESTING_MANAGEMENT_PARTIAL_TEST_REPORT') {
  params.push({ param_name: 'sample_inward_id', param_value: sample_inward_id });
}
  service.executeQuery({
    path,
    // query_params: {
    //   parameter_mapping: [
    //     { param_name: 'object_id', param_value: object_id },
    //     { param_name: 'reference_id', param_value: reference_id },
    //     {param_name:'sample_inward_id',param_value:sample_inward_id},
    //     { param_name: 'id', param_value: partial_id }
    //   ]
    // }
    query_params : { parameter_mapping: params }
  }, res => {
    let { custom_Fields, temp_data, footer_coa, footer_datasheet, investigation_coa } = res.data[0].temp_data;
    if (custom_Fields && custom_Fields.length > 0) {
      custom_Fields.map(item => {
        temp_data[item.key] = item.value
        return item;
      })
    }
    // if (custom_Fields?.length) {
    //   custom_Fields.forEach(item => {
    //     temp_data[item.key] = item.value;
    //   });
    // }

    let coa_template_data_fields_values = { ...temp_data };
    if (coa_template_data_fields_values && footer_coa?.length) {
      footer_coa.forEach(item => {
        coa_template_data_fields_values[item.key] = item.value;
        if (item.signature_attachment?.TypeimgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = item.signature_attachment.TypeimgSrc;
        }
        else if ( item.signature_attachment?.imgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = (item.signature_attachment?.imgSrc);
        }
      });
    }

    if (coa_template_data_fields_values.is_released === true && investigation_coa?.length) {
      

      investigation_coa.forEach(item => {
        const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
        const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
        const isFooterEmpty = footerData.every(item => !item.value);
        const footerItem = footer_coa.find(footerItem => footerItem.key === item.key);
        investigation_coa.forEach(item => {
          if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
            coa_template_data_fields_values[item.key] = item.value;
          }
        });
        if (item.key === 'approved_by') {
          if ((footerItem && item.value1 > footerItem.value1 && item.value)) {
            const details = investigation_coa.find(footerItem => footerItem.key === 'authorized_by')
            if (details === undefined) {
              coa_template_data_fields_values[item.key] = item.value;
            }
          }

        }
        if (item.key === 'authorized_by') {
          if (footerItem && item.value1 > footerItem.value1 && item.value) {
            coa_template_data_fields_values[item.key] = item.value;
          }}
      })
    }
    if (coa_template_data_fields_values) {
      if (coa_template_data_fields_values.checked_by === '') {
        coa_template_data_fields_values.checked_by = '--'
      }
      if (coa_template_data_fields_values.reviewed_by === '') {
        coa_template_data_fields_values.reviewed_by = '--'
      }
      if (coa_template_data_fields_values.approved_by === '') {
        coa_template_data_fields_values.approved_by = '--'
      }
      if (coa_template_data_fields_values.authorized_by === '') {
        coa_template_data_fields_values.authorized_by = '--'
      }
    }
    let datasheet_template_data_fields_values = { ...temp_data };
    if (footer_datasheet && footer_datasheet.length > 0) {
      footer_datasheet.map(item => {
        datasheet_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    cb({ coa_template_data_fields_values, datasheet_template_data_fields_values, investigation_coa });
  });
}

export const getTemplateFields2 = (path, object_id, reference_id, derived_coa_id, cb) => {
  service.executeQuery({
    path,
    query_params: {
      parameter_mapping: [
        { param_name: 'object_id', param_value: object_id },
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'derived_coa_id', param_value: derived_coa_id }
      ]
    }
  }, res => {
    let { custom_Fields, temp_data, footer_coa, footer_datasheet, investigation_coa, derived_coa } = res.data[0].temp_data;
    if (custom_Fields && custom_Fields.length > 0) {
      custom_Fields.map(item => {
        temp_data[item.key] = item.value
        return item;
      })
    }
    let coa_template_data_fields_values = { ...temp_data };
    if (coa_template_data_fields_values.is_released === true && footer_coa && footer_coa.length > 0) {
      footer_coa.map(item => {
        coa_template_data_fields_values[item.key] = item.value
        return item;
      })
  } 
    if (coa_template_data_fields_values.is_released === true && derived_coa && derived_coa.length > 0) {
      derived_coa.map(item => {
        coa_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    // if (investigation_coa && investigation_coa.length > 0) {
    //   const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
    //   const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
    //   const isFooterEmpty = footerData.every(item => !item.value);
    //   investigation_coa.forEach(item => {
    //     if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
    //       coa_template_data_fields_values[item.key] = item.value;
    //     }
    //   });
    // }
    if (coa_template_data_fields_values.is_released === true && investigation_coa && investigation_coa.length > 0) {
      investigation_coa.forEach(item => {
        if(item.value !== undefined && item.value !== null && item.value !== '') {
        coa_template_data_fields_values[item.key] = item.value;
        }
      });

      derived_coa?.forEach(item => {
        if(item.value !== undefined && item.value !== null && item.value !== '') {
        coa_template_data_fields_values[item.key] = item.value;
        }
      });

      if (investigation_coa?.length) {
        const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
        const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
        const isFooterEmpty = footerData.every(item => !item.value);

        investigation_coa.forEach(item => {
          const footerItem = footer_coa?.find(footerItem => footerItem.key === item.key);
          if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
            coa_template_data_fields_values[item.key] = item.value;
          }

        if (item.key === 'approved_by') {
          if ((footerItem && item.value1 > footerItem.value1 && item.value)) {
            const details = investigation_coa.find(footerItem => footerItem.key === 'authorized_by')
            if (details === undefined) {
              coa_template_data_fields_values[item.key] = item.value;
              }
            }
          }

        if (item.key === 'authorized_by') {
          if (footerItem && item.value1 > footerItem.value1 && item.value) {
            coa_template_data_fields_values[item.key] = item.value;
            }
          }
        });
      }
    }

    [
      'checked_by', 'reviewed_by', 'approved_by', 'authorized_by',
      'derived_prepared_by', 'sign_off_1', 'sign_off_2', 'sign_off_3', 'sign_off_4'
    ].forEach(key => {
      if (coa_template_data_fields_values[key] === '') {
        coa_template_data_fields_values[key] = '--';
      }
    });

    let datasheet_template_data_fields_values = { ...temp_data };
    if (footer_datasheet && footer_datasheet.length > 0) {
      footer_datasheet.map(item => {
        datasheet_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    cb({ coa_template_data_fields_values, datasheet_template_data_fields_values, investigation_coa });
  });
}


export const getTestingTemplateFields2 = (path, object_id, reference_id, derived_coa_id,sample_inward_id, cb) => {
  service.executeQuery({
    path,
    query_params: {
      parameter_mapping: [
        { param_name: 'object_id', param_value: object_id },
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'derived_coa_id', param_value: derived_coa_id },
        { param_name: 'sample_inward_id', param_value: sample_inward_id }

      ]
    }
  }, res => {
    let { custom_Fields, temp_data, footer_coa, footer_datasheet, investigation_coa, derived_coa } = res.data[0].temp_data;
    if (custom_Fields && custom_Fields.length > 0) {
      custom_Fields.map(item => {
        temp_data[item.key] = item.value
        return item;
      })
    }
    let coa_template_data_fields_values = { ...temp_data };
    if (coa_template_data_fields_values.is_released === true && footer_coa && footer_coa.length > 0) {
      footer_coa.map(item => {
        coa_template_data_fields_values[item.key] = item.value
        if (item.signature_attachment?.TypeimgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = item.signature_attachment.TypeimgSrc;
        }
        else if (item.signature_attachment?.imgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = (item.signature_attachment?.imgSrc);
        }
        return item;
      })
  } 
    if (coa_template_data_fields_values.is_released === true && derived_coa && derived_coa.length > 0) {
      derived_coa.map(item => {
        coa_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    // if (investigation_coa && investigation_coa.length > 0) {
    //   const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
    //   const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
    //   const isFooterEmpty = footerData.every(item => !item.value);
    //   investigation_coa.forEach(item => {
    //     if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
    //       coa_template_data_fields_values[item.key] = item.value;
    //     }
    //   });
    // }
    if (coa_template_data_fields_values.is_released === true && investigation_coa && investigation_coa.length > 0) {
      investigation_coa.forEach(item => {
        if (item.value !== undefined && item.value !== null && item.value !== '') {
          coa_template_data_fields_values[item.key] = item.value;
        }
      });

      derived_coa?.forEach(item => {
        coa_template_data_fields_values[item.key] = item.value;
      });

      if (investigation_coa?.length) {
        const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
        const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
        const isFooterEmpty = footerData.every(item => !item.value);

        investigation_coa.forEach(item => {
          const footerItem = footer_coa?.find(footerItem => footerItem.key === item.key);
          if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
            coa_template_data_fields_values[item.key] = item.value;
          }

        if (item.key === 'approved_by') {
          if ((footerItem && item.value1 > footerItem.value1 && item.value)) {
            const details = investigation_coa.find(footerItem => footerItem.key === 'authorized_by')
            if (details === undefined) {
              coa_template_data_fields_values[item.key] = item.value;
              }
            }
          }

        if (item.key === 'authorized_by') {
          if (footerItem && item.value1 > footerItem.value1 && item.value) {
            coa_template_data_fields_values[item.key] = item.value;
            }
          }
        });
      }
    }

    [
      'checked_by', 'reviewed_by', 'approved_by', 'authorized_by',
      'derived_prepared_by', 'sign_off_1', 'sign_off_2', 'sign_off_3', 'sign_off_4'
    ].forEach(key => {
      if (coa_template_data_fields_values[key] === '') {
        coa_template_data_fields_values[key] = '--';
      }
    });

    let datasheet_template_data_fields_values = { ...temp_data };
    if (footer_datasheet && footer_datasheet.length > 0) {
      footer_datasheet.map(item => {
        datasheet_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    cb({ coa_template_data_fields_values, datasheet_template_data_fields_values, investigation_coa });
  });
}


export const getTitleText = (me, text) => {
  const { app_configs } = me || {};

  const product = app_configs?.product || "LIMS-ELN";

  const PRODUCT_DISPLAY_NAMES = {
    LIMS: "Lab Iconics LIMS",
    ELN: "Lab Iconics ELN",
    "LIMS-ELN": "Lab Iconics LIMS-ELN",
    QMS: "Lab Iconics QMS",
    DMS: "Lab Iconics DMS"
  };

  const displayName = PRODUCT_DISPLAY_NAMES[product] || product;

  return `${displayName} - ${text}`;
};


export const PrintModal = ({ htmlContent,previewPageProps,reduxData,me,coaprintcount }) => {
  // console.log("PrintModal",htmlContent,previewPageProps,reduxData)
  const [showPrintOptions, setShowPrintOptions] = useState(true);
  const [printType,setPrintType]=useState("");
  const [showPrintPreview,setShowPrintPreview]=useState(false);
   const [data, setData] = useState({
      loaded: false,
      logo: undefined,
      hq: undefined,
    });
    useEffect(() => {
    const handleClosePrintModal = () => {
      setShowPrintOptions(false);
    };

    document.addEventListener('closePrintModal', handleClosePrintModal);

    return () => {
      document.removeEventListener('closePrintModal', handleClosePrintModal);
    };
  }, []);
  
    useEffect(() => {
      let hq = {};
      let p1 = new Promise((resolve, reject) => {
        let is_headquarter=me.current_auth.is_headquarter
        let old_headquarter_logo=(is_headquarter === false)?'utils/get_headquarter_logo_new':'utils/get_headquarter_logo'
			console.log('old_headquarter_logo: ', old_headquarter_logo);
        service.executeQuery(
          {
            path: old_headquarter_logo,
            query_params: {
              parameter_mapping: [
                { param_name: 'site_id', param_value: (reduxData && reduxData.current_auth?.site_id)?reduxData.current_auth?.site_id:me?.current_auth?.site_id}
              ]
            },
          },
          (res) => {
            if (res.data && res.data.length > 0) hq = res.data[0];
            setData((prev) => ({ ...prev, hq: res.data[0] }));
            resolve("");
          }
        );
      });
  
      Promise.all([p1])
        .then((values) => {
          if (hq) {
            service.getImageData(hq.id, (res) => {
              if (res.status === "ERROR") console.log("Logo not found");
              else setData((prev) => ({ ...prev, logo: res }));
            });
          }
          setData((prev) => ({ ...prev, loaded: true }));
        })
        .catch((error) => {
          console.log(error.message);
        });
    }, []);

  const handlePrint = (orientation) => {
    // Concatenate all CSS styles needed for print
    const css = `${matlIconCss}${styleCss}${mainCss}${printCss}${dmsPrintCss}`;
    const rootClass = document.getElementById("root").className;
    const emotionStyles = Array.from(document.querySelectorAll('style[data-emotion]'))
      .map(style => style.outerHTML)
      .join('');
    let styles = '';
    if (!emotionStyles) {
      styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map(el => el.outerHTML)
        .join('');
    }
  
    // Create the print-ready HTML with styling
    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
        ${styles || emotionStyles}
          <style>
            ${css}
             @media print {
          @page { size: ${orientation}; }
          * {
          animation: none !important;
          }
          }
          </style>
        </head>
        <body>
          <div id="root" class="${rootClass}">
            ${htmlContent}
          </div>
        </body>
      </html>
    `;
  console.log(printHtml,'printHtml');
  
    // Create an iframe to hold the print document
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    // Access the iframe's window and document to load the content
    const winPrint = iframe.contentWindow;
    winPrint.document.open();
    winPrint.document.write(printHtml);
    winPrint.document.close();
    

    iframe.onload = async () => {
      try {
        await winPrint.document.fonts.ready;
        await winPrint.document.fonts.load(
          '16px "Material Design Icons"'
        );
    
        winPrint.focus();
      } catch (error) {
        console.error("Print error:", error);
      } 
    };
    
    // Focus on the iframe and trigger print
    // winPrint.focus();
    setTimeout(() => {
      winPrint.print();
      winPrint.close();
      iframe.remove();
    }, 250); // Adjust if necessary for complex content
  
    setShowPrintOptions(false); // Hide the print options after print is triggered
  };

  const updateState =(hidePreview)=>{
    setShowPrintPreview(hidePreview);
    setPrintType("");
  }
  

  return (
  <>
    {(showPrintPreview && data.loaded && !!previewPageProps) ? <PrintPreviewPage previewPageProps={previewPageProps} printType={printType} updateState={updateState} reduxData={reduxData} reportHeaderData={data} coaprintcount={coaprintcount}/> :<></>}
    {showPrintOptions && (
      <div className="popup">
        <div className="modal is-active">
          <div className=""></div>
          <div className="modal-content">
            <div className="box">
              <h4 className="custom-title">Select Print Orientation</h4>
              <div className="buttons">
                <button className="button is-primary" onClick={(e) => {
                  if(!!previewPageProps && !!Object.keys(previewPageProps).length){
                  setPrintType("portrait");
                  setShowPrintPreview(true);
                  setShowPrintOptions(false);}
                  else{
                  handlePrint('portrait');
                  }
                }}
                  >
                    Portrait</button>
                <button className="button is-info" onClick={(e) => {
                  if(!!previewPageProps && !!Object.keys(previewPageProps).length){
                  setPrintType("landscape");
                  setShowPrintPreview(true);
                  setShowPrintOptions(false);}
                  else{
                  handlePrint('landscape');
                  }
                  }}>Landscape</button>
              </div>
            </div>
          </div>
          <button className="modal-close is-large" aria-label="close" style={{ marginTop: "45px" }} onClick={() => {setShowPrintOptions(false)}}></button>
        </div>
      </div>
    )}</>
  );
};

export const print = (html,previewPageProps,reduxData,me,coaprintcount) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  let excludeEles = ['.document-comparison','.wrapper-filters']
  excludeEles.forEach((element) => {
      tempDiv.querySelectorAll(element).forEach((ele) => {
          ele.remove();
      });
  });
  html = tempDiv.innerHTML;
  console.log('me:util ', me);
  const printRoot = document.createElement('div');
  document.body.appendChild(printRoot);
  const root = createRoot(printRoot);
  root.render(<PrintModal htmlContent={html} previewPageProps={previewPageProps} reduxData={reduxData} me={me} coaprintcount={coaprintcount}/>);
};

export const QmsPrintModal = ({ htmlContent,previewPageProps,reduxData,me }) => {
  // console.log("PrintModal",htmlContent,previewPageProps,reduxData)
  const [showPrintOptions, setShowPrintOptions] = useState(true);
  const [printType,setPrintType]=useState("");
  const [showPrintPreview,setShowPrintPreview]=useState(false);
   const [data, setData] = useState({
      loaded: false,
      logo: undefined,
      hq: undefined,
    });
    useEffect(() => {
    const handleClosePrintModal = () => {
      setShowPrintOptions(false);
    };

    document.addEventListener('closePrintModal', handleClosePrintModal);

    return () => {
      document.removeEventListener('closePrintModal', handleClosePrintModal);
    };
  }, []);
  
    useEffect(() => {
      let hq = {};
      let p1 = new Promise((resolve, reject) => {
        let is_headquarter=me.current_auth.is_headquarter
        let old_headquarter_logo=(is_headquarter === false)?'utils/get_headquarter_logo_new':'utils/get_headquarter_logo'
			console.log('old_headquarter_logo: ', old_headquarter_logo);
        service.executeQuery(
          {
            path: old_headquarter_logo,
            query_params: {
              parameter_mapping: [
                { param_name: 'site_id', param_value: (reduxData && reduxData.current_auth?.site_id)?reduxData.current_auth?.site_id:me?.current_auth?.site_id}
              ]
            },
          },
          (res) => {
            if (res.data && res.data.length > 0) hq = res.data[0];
            setData((prev) => ({ ...prev, hq: res.data[0] }));
            resolve("");
          }
        );
      });
  
      Promise.all([p1])
        .then((values) => {
          if (hq) {
            service.getImageData(hq.id, (res) => {
              if (res.status === "ERROR") console.log("Logo not found");
              else setData((prev) => ({ ...prev, logo: res }));
            });
          }
          setData((prev) => ({ ...prev, loaded: true }));
        })
        .catch((error) => {
          console.log(error.message);
        });
    }, []);

  const handlePrint = (orientation) => {
    // Concatenate all CSS styles needed for print
    const css = `${matlIconCss}${styleCss}${mainCss}${printCss}${qmsCss}${qmsreportsCss}${qmsPrintCss}`;
    const rootClass = document.getElementById("root").className;
    const emotionStyles = Array.from(document.querySelectorAll('style[data-emotion]'))
      .map(style => style.outerHTML)
      .join('');
    let styles = '';
    if (!emotionStyles) {
      styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map(el => el.outerHTML)
        .join('');
    }
  
    // Create the print-ready HTML with styling
    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
        ${styles || emotionStyles}
          <style>
            ${css}
             @media print {
          @page { size: ${orientation}; }
          * {
          animation: none !important;
          }
          }
          </style>
        </head>
        <body>
          <div id="root" class="${rootClass}">
            ${htmlContent}
          </div>
        </body>
      </html>
    `;
  console.log(printHtml,'printHtml');
  
    // Create an iframe to hold the print document
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    // Access the iframe's window and document to load the content
    const winPrint = iframe.contentWindow;
    winPrint.document.open();
    winPrint.document.write(printHtml);
    winPrint.document.close();
    
    // Focus on the iframe and trigger print
    winPrint.focus();
    setTimeout(() => {
      winPrint.print();
      winPrint.close();
      iframe.remove();
    }, 250); // Adjust if necessary for complex content
  
    setShowPrintOptions(false); // Hide the print options after print is triggered
  };

  const updateState =(hidePreview)=>{
    setShowPrintPreview(hidePreview);
    setPrintType("");
  }
  

  return (
  <>
    {(showPrintPreview && data.loaded && !!previewPageProps) ? <PrintPreviewPage previewPageProps={previewPageProps} printType={printType} updateState={updateState} reduxData={reduxData} reportHeaderData={data}/> :<></>}
    {showPrintOptions && (
      <div className="popup">
        <div className="modal is-active">
          <div className=""></div>
          <div className="modal-content">
            <div className="box">
              <h4 className="custom-title">Select Print Orientation</h4>
              <div className="buttons">
                <button className="button is-primary" onClick={(e) => {
                  if(!!previewPageProps && !!Object.keys(previewPageProps).length){
                  setPrintType("portrait");
                  setShowPrintPreview(true);
                  setShowPrintOptions(false);}
                  else{
                  handlePrint('portrait');
                  }
                }}
                  >
                    Portrait</button>
                <button className="button is-info" onClick={(e) => {
                  if(!!previewPageProps && !!Object.keys(previewPageProps).length){
                  setPrintType("landscape");
                  setShowPrintPreview(true);
                  setShowPrintOptions(false);}
                  else{
                  handlePrint('landscape');
                  }
                  }}>Landscape</button>
              </div>
            </div>
          </div>
          <button className="modal-close is-large" aria-label="close" style={{ marginTop: "45px" }} onClick={() => {setShowPrintOptions(false)}}></button>
        </div>
      </div>
    )}</>
  );
};

export const qmsprint = (html,previewPageProps,reduxData,me) => {
  console.log('me:util ', me);
  const printRoot = document.createElement('div');
  document.body.appendChild(printRoot);
  const root = createRoot(printRoot);
  root.render(<QmsPrintModal htmlContent={html} previewPageProps={previewPageProps} reduxData={reduxData} me={me}/>);
};

export const GraphPrintModal = ({ htmlContent,previewPageProps,reduxData }) => {
  const [showPrintOptions, setShowPrintOptions] = useState(true);
  const [printType,setPrintType]=useState("");
  const [showPrintPreview,setShowPrintPreview]=useState(false);
  const [data, setData] = useState({
      loaded: false,
      logo: undefined,
      hq: undefined,
    });
    useEffect(() => {
      let hq = {};
      let p1 = new Promise((resolve, reject) => {
        service.executeQuery(
          {
            path: "utils/get_headquarter_logo",
            query_params: {},
          },
          (res) => {
            if (res.data && res.data.length > 0) hq = res.data[0];
            setData((prev) => ({ ...prev, hq: res.data[0] }));
            resolve("");
          }
        );
      });
  
      Promise.all([p1])
        .then((values) => {
          if (hq) {
            service.getImageData(hq.id, (res) => {
              if (res.status === "ERROR") console.log("Logo not found");
              else setData((prev) => ({ ...prev, logo: res }));
            });
          }
          setData((prev) => ({ ...prev, loaded: true }));
        })
        .catch((error) => {
          console.log(error.message);
        });
    }, []);
  const handlePrint = (orientation) => {
    const css = `${matlIconCss}${styleCss}${mainCss}${printCss}${qmsCss}${qmsreportsCss}`;
    const rootClass = document.getElementById("root").className;
    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            ${css}
            @media print {
          @page { size: ${orientation}; }
          * {
          animation: none !important;
          }
          }
          </style>
        </head>
        <body>
          <div id="root" class="${rootClass}">
            ${htmlContent}
          </div>
        </body>
      </html>
    `;
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    const winPrint = iframe.contentWindow;
    winPrint.document.open();
    winPrint.document.write(printHtml);
    winPrint.document.close();
    winPrint.focus();
    setTimeout(() => {
      winPrint.print();
      winPrint.close();
      iframe.remove();
    }, 250);
    setShowPrintOptions(false);
  };
  const updateState =(hidePreview)=>{
    setShowPrintPreview(hidePreview);
    setPrintType("");
  }
  return (
  <>
    {(showPrintPreview && data.loaded && !!previewPageProps) ? <PrintPreviewPage previewPageProps={previewPageProps} printType={printType} updateState={updateState} reduxData={reduxData} reportHeaderData={data}/> :<></>}
    {showPrintOptions && (
      <div className="popup">
        <div className="modal is-active">
          <div className=""></div>
          <div className="modal-content">
            <div className="box">
              <h4 className="custom-title">Select Print Orientation</h4>
              <div className="buttons">
                <button className="button is-primary" onClick={(e) => {
                  if(!!previewPageProps && !!Object.keys(previewPageProps).length){
                  setPrintType("portrait");
                  setShowPrintPreview(true);
                  setShowPrintOptions(false);}
                  else{
                  handlePrint('portrait');
                  }
                }}
                  >
                    Portrait</button>
                <button className="button is-info" onClick={(e) => {
                  if(!!previewPageProps && !!Object.keys(previewPageProps).length){
                  setPrintType("landscape");
                  setShowPrintPreview(true);
                  setShowPrintOptions(false);}
                  else{
                  handlePrint('landscape');
                  }
                  }}>Landscape</button>
              </div>
            </div>
          </div>
          <button className="modal-close is-large" aria-label="close" onClick={() => {setShowPrintOptions(false)}}></button>
        </div>
      </div>
    )}</>
  );
};

export const GraphPrint = (html,previewPageProps,reduxData) => {
  const printRoot = document.createElement('div');
  document.body.appendChild(printRoot);
  const root = createRoot(printRoot);
  root.render(<GraphPrintModal htmlContent={html} previewPageProps={previewPageProps} reduxData={reduxData}/>);
};

export const FishPrintModal = ({ htmlContent,value }) => {
  const handlePrint = (orientation) => {
    // Concatenate all CSS styles needed for print
    const css = `${matlIconCss}${styleCss}${mainCss}${printCss}${qmsCss}${qmsreportsCss}`;
    const rootClass = document.getElementById("root").className;
  
    // Create the print-ready HTML with styling
    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            ${css}
            @media print {
              @page { size: ${orientation}; }
            }
          </style>
        </head>
        <body>
          <div id="root" class="${rootClass}">
            ${htmlContent}
          </div>
        </body>
      </html>
    `;
  
    // Create an iframe to hold the print document
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  
    // Access the iframe's window and document to load the content
    const winPrint = iframe.contentWindow;
    winPrint.document.open();
    winPrint.document.write(printHtml);
    winPrint.document.close();
    
    // Focus on the iframe and trigger print
    winPrint.focus();
    setTimeout(() => {
      winPrint.print();
      winPrint.close();
      iframe.remove();
    }, 250); // Adjust if necessary for complex content
  

  };
  if (value) {
    handlePrint('landscape');
  }
  return null; 
};
export const fishPrint = (html,value) => {
  console.log("html", html, "value", value )
  const printRoot = document.createElement('div');
  document.body.appendChild(printRoot);
  const root = createRoot(printRoot);
  root.render(<FishPrintModal htmlContent={html} value={value} />);
};


// export const print = (html) => {
//   let css = matlIconCss + styleCss + mainCss + printCss;
//   let rootClass = document.getElementById("root").className;
//   let printHtml = `<!DOCTYPE html><html><head><style>` + css + `</style></head><body><div id="root" class="` + rootClass + `">` + html + `</div></body></html>`;
//   let iframe = document.createElement("iframe");
//   iframe.style = "display:none";
//   document.body.appendChild(iframe);
//   let winPrint = iframe.contentWindow;
//   winPrint.document.open();
//   winPrint.document.write(printHtml);
//   winPrint.document.close();
//   winPrint.focus();
//   setTimeout(() => {
//     winPrint.print();
//     winPrint.close();
//     iframe.remove();
//   }, 250);
// }


export const removeItem1 = (arr, value) => {
  if (!Array.isArray(arr)) return [];
  var index = arr.indexOf(value);
  if (index > -1) {
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  }
  return arr;
};
export const removeItem = (arr, value) => {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export const getString = (str) => {
  let ret = str;
  if (str === "INSERT") ret = "CREATE";
  return ret;
}

export const trimDecimalPlaces = (number, maxDecimal) => {
  let ret = number;
  let number_str = number + '';
  let decimal = undefined;
  if (number_str.indexOf(".") > -1) decimal = number_str.split('.')[1].length || 0;
  if (decimal && decimal > 6) ret = number.toFixed(maxDecimal);
  return ret;
}

export const getCustomFields = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'utils/get_custom_fields',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}
export const getCustomFieldsView = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'utils/get_custom_fieldsView',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}


export const getCustomFieldsview = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'utils/get_custom_fields2',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}

export const sortArray = (arr, prop, typeOf, sortOrder) => {
  if (arr && arr.length > 0) {
    arr.sort((ob1, ob2) => {
      if (typeOf === 'number' && ob1[prop] && ob2[prop]) {
        return (sortOrder === 'asc') ? (ob1[prop] - ob2[prop]) : (ob2[prop] - ob1[prop]);
      } else if (typeOf === 'string' && ob1[prop] && ob2[prop]) {
        return (sortOrder === 'asc') ? ob1[prop]?.localeCompare(ob2[prop]) : ob2[prop]?.localeCompare(ob1[prop]);
      }
      return '';
    })
  }
  return arr;
};

export const checkApproval = (menu_id, site_id, cb) => {
  service.executeQuery({
    path: 'utils/check_approval',
    query_params: {
      parameter_mapping: [
        { param_name: 'menu_id', param_value: menu_id },
        { param_name: 'site_id', param_value: site_id }
      ]
    }
  }, res => {
    let is_active_approval = res && res.data[0] ? res.data[0].signoffs_active === 1 ? true : false : false
    cb({ is_active_approval });
  });
}


export const getQMSCustomFields = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'qms_utils/get_custom_fields',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}
export const getQMSCustomFieldsview = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'qms_utils/get_custom_fields1',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}

export const getDMSCustomFields = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'dms_utils/get_custom_fields',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}

export const getDMSCustomFieldsview = (reference_id, site_id, menu_id, cb) => {
  service.executeQuery({
    path: 'dms_utils/get_custom_fields1',
    query_params: {
      parameter_mapping: [
        { param_name: 'reference_id', param_value: reference_id },
        { param_name: 'site_id', param_value: site_id },
        { param_name: 'menu_id', param_value: menu_id }
      ]
    }
  }, res => {
    let customFields = res.data;
    let optional_fields = res.data.filter(item => !item.show_by_default)
    cb({ customFields, optional_fields });
  });
}
export const getHtml = (html) => {
  const pdfstyle = `#printNode {
                        padding: 10px !important;
                      }
                      .print-border {
                        border-width: 3px;
                        border-style: solid;
                        border-color: #729eae;
                        border-radius: 5px;
                        left: 0;
                        right: 0;
                        top: 5px;
                        bottom: 5px;
                        position: fixed;}
 
                        #root{
                        height: 100%;
                        padding-top: 4rem !important;}
                        
                        .watermark {
                        visibility: visible;
                        position: fixed;
                        bottom: 33px;
                        right: 10px;
                        text-align: center;
                        z-index: 5;}
                    `;
  const css = `${styleCss}${mainCss}${printCss}${pdfstyle}${qmsCss}${qmsreportsCss}`;
  const rootClass = document.getElementById("root")?.className || "";
  const printHtml = `
                    <html>
                      <head>
                        <style>
                          ${css}
                        </style>
                      </head>
                      <body>
                        <div id="root" class="${rootClass}">
                          ${html}
                        </div>
                      </body>
                    </html>
                  `;
 
  return printHtml;
};
export const getActiveUser = (id, cb) => {
  service.executeQuery({
    path: 'utils/get_user',
    query_params: {
      parameter_mapping: [
        { param_name: 'id', param_value: id }
      ]
    }
  }, res => {
    let active_analyst = res && res.data[0] ? (res.data[0].status_id === 'ACTIVE')? true : false : false
    cb({ active_analyst });
  });
}

const  formatDate=()=> {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[now.getMonth()];
  const year = now.getFullYear();

  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${day}-${month}-${year} [${hours}:${minutes}:${seconds}]`;
}

// const  formatDatefordownload=()=> {
//   const now = new Date();
//   const day = String(now.getDate()).padStart(2, '0');
//   const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
//                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const month = monthNames[now.getMonth()];
//   const year = now.getFullYear();
//   const hours = String(now.getHours()).padStart(2, '0');
//   const minutes = String(now.getMinutes()).padStart(2, '0');
//   const seconds = String(now.getSeconds()).padStart(2, '0');
//   const ampm = hours >= 12 ? 'PM' : 'AM';
//   return `${day}-${month}-${year} [${hours}:${minutes} ${ampm}]`;
// }
const formatDatefordownload = (me) => {
  const now = getNow("YYYY-MM-DDTHH:mm:ss.SSS");
  const tz = me.meta.is_root_user ? 'UTC' :me?.current_auth?.time_zone_value || 'Asia/Kolkata';
  const df = me.meta.is_root_user ? 'DD-MMM-YYYY' :me?.current_auth?.date_format || 'DD-MMM-YYYY';
  const tf = convertMomentTimeFormat(me.meta.is_root_user ? 'HH24:MI' : me?.current_auth?.time_format_value) || 'hh:mm A';
  const d_tz = dayjs(now).tz(tz);
  const formattedDate = d_tz.format(df);
  const formattedTime = d_tz.format(tf);
  return me.meta.is_root_user ? `${formattedDate} [${formattedTime}] UTC`.toUpperCase() : `${formattedDate} [${formattedTime}]`.toUpperCase();
};

const hexStringToUint8Array =(hexString)=> {
    if (hexString.startsWith('\\x')) {
        hexString = hexString.slice(2); // Remove \x
    }
    const bytes = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
        bytes[i / 2] = parseInt(hexString.substr(i, 2), 16);
    }
    return bytes;
}

const uint8ToBase64=(bytes) => {
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

// xlsx - entire data in differnt sheets with image and text and styles
export const downloadCSVForLargeData = async (jsonData, cb,extraData) => {
  const downloadBy = extraData.first_name + " " + extraData.last_name
  const workbook = new ExcelJS.Workbook();
  const totalRows = jsonData.length;
  const chunkSize = 100000; // 1 lakh rows per sheet
  const headers = Object.keys(jsonData[0]);
  const totalSheets = Math.ceil(totalRows / chunkSize);

  const hexString = extraData?.excelHeaderLogo;
  let imageId = null;
  if (hexString) {
    const byteArray = hexStringToUint8Array(hexString);
    const base64String = uint8ToBase64(byteArray);

    imageId = workbook.addImage({
      base64: base64String,
      extension: 'jpeg'
    });
  }
  for (let sheetIndex = 0; sheetIndex < totalSheets; sheetIndex++) {
    const worksheet = workbook.addWorksheet(`Data_${sheetIndex + 1}`);
    if (imageId !== null && imageId !== undefined) {
      worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 563, height: 84 }
      });
    }
    const siteName = extraData.me.current_auth?.site_label || 'N/A';
    const siteAddress = [
      extraData.me.current_auth?.address1,
    ].filter(Boolean).join(' ') || 'N/A';

    const textLines = [
      `Site Name : ${siteName}`,
      `Site Address : ${siteName},${siteAddress},`,
      `${extraData.me.current_auth?.address2},${extraData.me.current_auth?.address4},`,
      `${extraData.me.current_auth?.city},${extraData.me.current_auth?.state},${extraData.me.current_auth?.country_name}`,
      `Downloaded By : ${downloadBy}`,
      `Downloaded On : ${formatDatefordownload(extraData.me)}`,
      console.log('formatDatefordownload(extraData.me): ', formatDatefordownload(extraData.me))
    ];

    for (let i = 0; i < textLines.length; i++) {
      const row = worksheet.getRow(i + 1);
      row.getCell(6).value = textLines[i];
      row.getCell(6).font = { name: 'Arial', size: 10, bold: true };
    }

    for (let i = 0; i < textLines.length; i++) {
      worksheet.mergeCells(i + 1, 3, i + 1, 5);
    }

    const headerRowIndex = 8;
    worksheet.getRow(headerRowIndex).values = headers;

    const headerRow = worksheet.getRow(headerRowIndex);
    headerRow.font = { bold: true, size: 12 };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

    const start = sheetIndex * chunkSize;
    const end = Math.min(start + chunkSize, totalRows);

    for (let i = start; i < end; i++) {
      const rowValues = headers.map((key) => jsonData[i][key]);
      worksheet.getRow(headerRowIndex + 1 + (i - start)).values = rowValues;

      if ((i - start) % 10000 === 0) {
        await new Promise((r) => setTimeout(r, 0));
      }
    }

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 25;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 35;

    headers.forEach((header, idx) => {
      worksheet.getColumn(idx + 1).width = Math.max(header.length + 5, 15);
    });
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, extraData.fileName);
  cb()
};

export const getDerivedTemplateFields = (path, object_id, reference_id,der_id , cb) => {
  service.executeQuery({
    path,
    query_params: {
      parameter_mapping: [
        { param_name: 'object_id', param_value: object_id },
        { param_name: 'reference_id', param_value: reference_id },
        { param_name : 'der_id' , param_value : der_id}
      ]
    }
  }, res => {
    let { custom_Fields, temp_data, footer_coa, footer_datasheet, investigation_coa } = res.data[0].temp_data;
    if (custom_Fields && custom_Fields.length > 0) {
      custom_Fields.map(item => {
        temp_data[item.key] = item.value
        return item;
      })
    }
    // if (custom_Fields?.length) {
    //   custom_Fields.forEach(item => {
    //     temp_data[item.key] = item.value;
    //   });
    // }

    let coa_template_data_fields_values = { ...temp_data };
    if (coa_template_data_fields_values && footer_coa?.length) {
      footer_coa.forEach(item => {
        coa_template_data_fields_values[item.key] = item.value;
        if (item.signature_attachment?.TypeimgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = item.signature_attachment.TypeimgSrc;
        }
        else if ( item.signature_attachment?.imgSrc) {
          coa_template_data_fields_values[item.key + '_signature'] = (item.signature_attachment?.imgSrc);
        }
      });
    }

    if (coa_template_data_fields_values.is_released === true && investigation_coa?.length) {
      

      investigation_coa.forEach(item => {
        const footerKeys = ['checked_by', 'reviewed_by', 'approved_by', 'authorized_by'];
        const footerData = footer_coa.filter(item => footerKeys.includes(item.key));
        const isFooterEmpty = footerData.every(item => !item.value);
        const footerItem = footer_coa.find(footerItem => footerItem.key === item.key);
        investigation_coa.forEach(item => {
          if (footerKeys.includes(item.key) && coa_template_data_fields_values[item.key] === '' && isFooterEmpty) {
            coa_template_data_fields_values[item.key] = item.value;
          }
        });
        if (item.key === 'approved_by') {
          if ((footerItem && item.value1 > footerItem.value1 && item.value)) {
            const details = investigation_coa.find(footerItem => footerItem.key === 'authorized_by')
            if (details === undefined) {
              coa_template_data_fields_values[item.key] = item.value;
            }
          }

        }
        if (item.key === 'authorized_by') {
          if (footerItem && item.value1 > footerItem.value1 && item.value) {
            coa_template_data_fields_values[item.key] = item.value;
          }}
      })
    }
    if (coa_template_data_fields_values) {
      if (coa_template_data_fields_values.checked_by === '') {
        coa_template_data_fields_values.checked_by = '--'
      }
      if (coa_template_data_fields_values.reviewed_by === '') {
        coa_template_data_fields_values.reviewed_by = '--'
      }
      if (coa_template_data_fields_values.approved_by === '') {
        coa_template_data_fields_values.approved_by = '--'
      }
      if (coa_template_data_fields_values.authorized_by === '') {
        coa_template_data_fields_values.authorized_by = '--'
      }
    }
    let datasheet_template_data_fields_values = { ...temp_data };
    if (footer_datasheet && footer_datasheet.length > 0) {
      footer_datasheet.map(item => {
        datasheet_template_data_fields_values[item.key] = item.value
        return item;
      })
    }
    cb({ coa_template_data_fields_values, datasheet_template_data_fields_values, investigation_coa });
  });
}

export function HtmlDiffHighlighter({ a = "", b = "" }) {
  const { highlightedA, highlightedB } = useMemo(() => diffAndHighlight(a, b), [a, b]);

  return (
    <div  className="dms-history-page" style={{ display: "flex", width: "100%", minHeight: "297mm", gap:"4%", height: "1000px", overflowY: "scroll", border:"15px solid #e9ecef", background:"#e9ecef"}}>
      <div className="border rounded-lg" style={{width:"47%"}}>
        {/* <h3 className="text-lg font-semibold mb-2">A (compared to B)</h3> */}
        <div className="prose max-w-none" style={{width:"100%", height:"100%"}} dangerouslySetInnerHTML={{ __html: highlightedA }} />
      </div>

      <div className="border rounded-lg" style={{width:"49%"}}>
        {/* <h3 className="text-lg font-semibold mb-2">B (compared to A)</h3> */}
        <div className="prose max-w-none " style={{width:"100%", height:"100%"}} dangerouslySetInnerHTML={{ __html: highlightedB }} />
      </div>

      <style>{`
        .diff-removed { background-color: hsl(348deg, 86%, 61%); padding: 0 2px; border-radius: 2px; }
        .diff-added   { background-color: hsl(44deg, 100%, 77%); padding: 0 2px; border-radius: 2px; }
      `}</style>
    </div>
  );
}

export function diffAndHighlight(htmlA, htmlB) {
  if (typeof document === "undefined") return { highlightedA: htmlA, highlightedB: htmlB };

  const parser = new DOMParser();
  const docA = parser.parseFromString(htmlA || "", "text/html");
  const docB = parser.parseFromString(htmlB || "", "text/html");

  const tokensA = tokenizeTextNodes(docA.body);
  const tokensB = tokenizeTextNodes(docB.body);

  const wordsA = tokensA.map((t, i) => ({ text: normWord(t.text), idx: i })).filter((w) => w.text !== null);
  const wordsB = tokensB.map((t, i) => ({ text: normWord(t.text), idx: i })).filter((w) => w.text !== null);

  const seqA = wordsA.map((w) => w.text);
  const seqB = wordsB.map((w) => w.text);

  const lcsPairs = lcsIndices(seqA, seqB); 

  const matchedA = new Set(lcsPairs.map(([ia, ib]) => wordsA[ia].idx));
  const matchedB = new Set(lcsPairs.map(([ia, ib]) => wordsB[ib].idx));

  const highlightedA = replaceTokensWithSpans(docA.body, tokensA, matchedA, true);
  const highlightedB = replaceTokensWithSpans(docB.body, tokensB, matchedB, false);

  return { highlightedA, highlightedB };
}

function tokenizeTextNodes(root) {
  // const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        const parent = node.parentNode;

        // 🚫 Skip table structural elements
        if (
          parent.closest("colgroup") ||
          parent.closest("col") ||
          parent.closest("thead") ||
          parent.closest("tbody") === null && parent.closest("table")
        ) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );
  const tokens = [];
  let node;
  while ((node = walker.nextNode())) {
    const text = node.nodeValue;
    if (!text) continue;
    const parts = text.split(/(\w+|[^\w]+)/).filter((p) => p !== undefined && p !== "");
    for (const part of parts) {
      tokens.push({ text: part, node });
    }
  }
  return tokens;
}

function normWord(token) {
  if (/^\w+$/i.test(token)) return token.toLowerCase();
  return null;
}

function lcsIndices(a, b) {
  const n = a.length, m = b.length;
  const dp = Array.from({ length: n + 1 }, () => Array(m + 1).fill(0));
  for (let i = n - 1; i >= 0; --i) {
    for (let j = m - 1; j >= 0; --j) {
      dp[i][j] = a[i] === b[j] ? 1 + dp[i+1][j+1] : Math.max(dp[i+1][j], dp[i][j+1]);
    }
  }
  const pairs = [];
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { pairs.push([i, j]); i++; j++; }
    else if (dp[i+1][j] >= dp[i][j+1]) i++; else j++;
  }
  return pairs;
}

function replaceTokensWithSpans(root, tokens, matchedSet, isA) {
  const byNode = new Map();
  // Group tokens by their original text node
  tokens.forEach((t, idx) => {
    if (!byNode.has(t.node)) byNode.set(t.node, []);
    byNode.get(t.node).push({ ...t, idx });
  });

  for (const [textNode, list] of byNode.entries()) {
    const parent = textNode.parentNode;
    if (!parent) continue;

    // 🚫 Skip table structural elements (VERY IMPORTANT)
    if (
      parent.closest("colgroup") ||
      parent.closest("col") ||
      parent.nodeName === "COLGROUP" ||
      parent.nodeName === "COL"
    ) {
      continue;
    }

    // Build HTML pieces
    const htmlPieces = list.map((tk) => {
      const isWord = normWord(tk.text) !== null;
      const isMatched = matchedSet.has(tk.idx);

      if (isWord) {
        if (isMatched) {
          return escapeHtml(tk.text);
        }
        return `<span class="${isA ? "diff-removed" : "diff-added"}">${escapeHtml(tk.text)}</span>`;
      }

      return escapeHtml(tk.text);
    });

    // ✅ Use fragment instead of wrapping span
    const fragment = document.createDocumentFragment();
    const temp = document.createElement("span"); // temp parser only
    temp.innerHTML = htmlPieces.join("");

    while (temp.firstChild) {
      fragment.appendChild(temp.firstChild);
    }

    parent.replaceChild(fragment, textNode);
  }

  // 🧹 Cleanup empty colgroups (extra safety)
  const colgroups = root.querySelectorAll("colgroup");
  colgroups.forEach((cg) => {
    if (!cg.children.length) {
      cg.remove();
    }
  });

  return root.innerHTML;
}

function escapeHtml(str) {
  return str.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;");
}

export const transformDatabaseFieldsToFormatBuilder = (recipe) =>{
  if (!recipe.fields || !Array.isArray(recipe?.fields)) {
      return [];
  }
  const separatorValues = ['ulr_slash', 'ulr_dash', 'ulr_dot', 'ulr_underscore', 'ulr_none'];
  const fieldValuesOnly = recipe?.fields.filter(field => 
      !separatorValues.includes(field?.ulr_field?.value)
  );
  return fieldValuesOnly.map((field, index) => {
      const fieldValue = field?.ulr_field?.value;
      const fieldType = getFieldType(fieldValue);
      const fieldLabel = getFieldLabel(fieldValue);
      return {
          id: `field-${index}`,
          type: fieldType,
          value: fieldValue === 'text' ? (recipe?.text || '') : fieldValue === 'custom_field' ? (recipe?.custom_field_name || recipe?.custom_fields_name || '') :  '',
          unique: field?.is_unique || false,
          seqDigits: recipe?.ulr_seq ? String(recipe?.ulr_seq) : '6',
          selectedOption: getSelectedOption(fieldValue, recipe),
          options: getOptions(fieldValue, recipe),
          ulr_field: { 
              label: fieldLabel, 
              value: fieldValue 
          }
      };
  });
}

export const extractSeparatorsFromFields = (recipe) => {
    if (!recipe?.fields || !Array.isArray(recipe?.fields)) {
        return ['/'];
    }
    const separators = [];
    const separatorMap = {
        'ulr_slash': '/',
        'ulr_dash': '-',
        'ulr_dot': '.',
        'ulr_underscore': '_',
        'ulr_none': ''
    };
    recipe?.fields?.forEach(field => {
        const sepValue = separatorMap[field?.ulr_field?.value];
        if (sepValue !== undefined) {
            separators?.push(sepValue);
        }
    });
    return separators?.length > 0 ? separators : ['/'];
};

export const extractTimeFormat = (recipe) => {
    if (!recipe?.ulr_year) return 'YY';
    const year = recipe?.ulr_year;
    if (year.length === 4 && /^\d{4}$/.test(year)) {
        return 'YYYY';
    }
    if (year.includes('Q')) {
        return 'YYQ';
    }
    if (year.length === 4 && /\d{2}\d{2}/.test(year)) {
        return 'YYMM';
    }
    return 'YY';
};

const getFieldType = (fieldValue) => {
    const typeMap = {
        'ulr_year': 'year',
        'ulr_seq': 'sequence',
        'site_code': 'site_code',
        'department': 'dept_code',
        'module_code': 'module_code',
        'text': 'custom_text',
        'custom_field': 'custom_field',
        'change_type': 'change_type',
        'ch_control_category': 'ch_control_category'
    };
    return typeMap[fieldValue] || 'unknown';
};

const getFieldLabel = (fieldValue) => {
    const labelMap = {
        'ulr_year': 'Year',
        'ulr_seq': 'Sequence Number',
        'site_code': 'Site Code',
        'department': 'Department',
        'module_code': 'Module Code',
        'text': 'Custom Text',
        'custom_field': 'Custom Field',
        'change_type': 'Change Type',
        'ch_control_category': 'Initial Categorization of Change'
    };
    return labelMap[fieldValue] || fieldValue;
};

const getSelectedOption = (fieldValue, recipe) => {
    if (fieldValue === 'site_code') return recipe?.site_code || 'SITE';
    if (fieldValue === 'department') return recipe?.department || 'DEPT';
    if (fieldValue === 'module_code') return recipe?.mod_code || 'CC';
    if (fieldValue === 'change_type') return recipe?.change_type || 'CT';
    if (fieldValue === 'ch_control_category') return recipe?.init_change_cat || 'ICC';
    if (fieldValue === 'custom_field') {
        return recipe?.custom_fields_id || recipe?.custom_field_id || recipe?.custom_field_name || '';
    }
    return null;
};

const getOptions = (fieldValue, recipe) => {
    if (fieldValue === 'site_code') {
        return recipe?.site_code ? [recipe?.site_code] : ['SITE'];
    }
    if (fieldValue === 'department') {
        return recipe?.department ? [recipe?.department] : ['DEPT'];
    }
    if (fieldValue === 'module_code') {
        return recipe?.mod_code ? [recipe?.mod_code] : [];
    }
    if (fieldValue === 'change_type') {
        return recipe?.change_type ? [recipe?.change_type] : ['CT'];
    }
    if (fieldValue === 'ch_control_category') {
        return recipe?.init_change_cat ? [recipe?.init_change_cat] : ['ICC'];
    }
    if (fieldValue === 'custom_field') {
        if ((recipe?.custom_fields_id || recipe?.custom_field_id) && (recipe?.custom_fields_name || recipe?.custom_field_name)) {
            return [{
                value: (recipe?.custom_fields_id || recipe?.custom_field_id),
                label: (recipe?.custom_fields_name || recipe?.custom_field_name)
            }];
        }
        return [];
    }
    return [];
};

export const getSiteApprovalStatus = async ({ module_id, menu_id, site_id }) => {
    try {
        const response = await new Promise((resolve, reject) => {
            service.executeQuery(
                {
                    path: 'admin/sites/get_site',
                    query_params: {
                        parameter_mapping: [
                            { param_name: "module_id", param_value: module_id },
                            { param_name: "menu_id", param_value: menu_id },
                            { param_name: "site_id", param_value: site_id }
                        ],
                    },
                },
                resolve,
                reject
            );
        });
        return response?.data?.[0] ?? [];
    } catch (error) {
        return false;
    }
};